import React from "react";
import MaterialTable from "material-table";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

function TableUsers({
  handleClickOpen,
  entries,
  roles,
  handlePrimaryRoleChange,
}) {
  return (
    <div>
      <MaterialTable
        localization={{
          pagination: {
            labelDisplayedRows: "{from}-{to} de {count}",
            labelRowsPerPage: "Filas por página",
            labelRowsSelect: "Filas",
            firstAriaLabel: "Primera página",
            firstTooltip: "Primera página",
            previousAriaLabel: "Página anterior",
            previousTooltip: "Página anterior",
            nextAriaLabel: "Próxima página",
            nextTooltip: "Próxima página",
            lastAriaLabel: "Última página",
            lastTooltip: "Última página",
          },
          toolbar: {
            nRowsSelected: "{0} filas(s) seleccionadas",
            searchTooltip: "Buscar",
            searchPlaceholder: "Buscar",
          },
          header: {
            actions: "Acciones",
          },
          body: {
            emptyDataSourceMessage: "No hay usuarios para mostrar",
            deleteTooltip: "Eliminar",
            editTooltip: "Editar",
            filterRow: {
              filterTooltip: "Filtrar",
            },
            editRow: {
              saveTooltip: "Guardar",
              cancelTooltip: "Cancelar",
              deleteText: "¿Está seguro que desea eliminar el usuario?",
            },
          },
        }}
        actions={[
          {
            icon: "edit",
            tooltip: "Editar",
            onClick: (event, rowData) => handleClickOpen(event, rowData),
          },
        ]}
        title="Usuarios"
        columns={[
          { title: "Nombre", field: "name" },
          { title: "Apellido", field: "lastName" },
          { title: "Telefono", field: "phoneNumber" },
          {
            title: "Rol",
            field: "role",
            render: (user) => (
              <div>
                <Select
                  name="role"
                  fullWidth
                  labelId="role"
                  value={user.role}
                  onChange={(event) => handlePrimaryRoleChange(event, user)}
                  id="role"
                >
                  {roles.map !== undefined &&
                    roles.map((role) => (
                      <MenuItem key={role.id} value={role.id}>
                        {role.description}
                      </MenuItem>
                    ))}
                </Select>
              </div>
            ),
          },
        ]}
        data={entries.data}
      />
    </div>
  );
}

export default React.memo(TableUsers);
